{
  "dismiss": "Ignora"
}
